import { Box, Skeleton } from '@mui/material'

export const SkeletonHeading = () => (
  <Box>
    <Skeleton height={50} />
  </Box>
)

export const SkeletonCategories = () => (
  <Box>
    <Skeleton height={40} />
    <Skeleton height={40} />
    <Skeleton height={40} />
    <Skeleton height={40} />
    <Skeleton height={40} />
    <Skeleton height={40} />
    <Skeleton height={40} />
    <Skeleton height={40} />
    <Skeleton height={40} />
    <Skeleton height={40} />
    <Skeleton height={40} />
    <Skeleton height={40} />
    <Skeleton height={40} />
    <Skeleton height={40} />
    <Skeleton height={40} />
    <Skeleton height={40} />
  </Box>
)
